import breakpoints from '../../../theme/breakpoints'

import css from 'styled-jsx/css'

export default css.global`
  .shows-wrapper {
    width: fit-content;
    margin: 0 auto;
    padding-top: 24px; 
  }
  
  .shows-container {
    display: inline-block;
    padding: 30px 12px;
    max-width: 720px;
  }
  
  .top-section {
    display: flex;
    gap: 20px;
    margin-bottom: 30px;
  }
  
  .teaser {
    width: 75%;
  }
  
  .blurb {
    width: 25%;
    font-size: 14px;
    font-weight: 600;
  }
  
  .text {
    margin: 30px 0 0 5px; 
  }
  
  .main-layout-sidebar {
    display: inline-block;
    vertical-align: top;
    padding-top: 30px;
    margin-left: 14px;
    top: 120px;
  }
  
  .ads-block {
    display: grid;
    grid-template-rows: 1fr 1fr;
    row-gap: 37px;
  }
  
  .top-stories {
    display: flex;
    flex-wrap: wrap;
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    .shows-wrapper {
      padding-top: 0; 
    }
    
    .top-section {
      flex-direction: column;
      padding: 0 16px;
    }
    
    .teaser {
      width: 100%;
    }
    
    .image {
      width: 30%;
    }
    
    .text {
      width: 70%;
      margin: 0 0 0 20px;
    }
    
    // p {
    //   margin-top: 0;
    // }
    
    .blurb {
      width: 100%;
      display: flex;
    }
  }
  
  @media only screen and (max-width: 1280px) {
    .main-layout-sidebar {
      display: none;
    }
  }
`
